import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-component-id"]
const _hoisted_2 = { class: "resizers" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "editWrapper",
    class: _normalizeClass(["edit-wrapper", { active: _ctx.active, hidden: _ctx.hidden }]),
    style: _normalizeStyle(_ctx.styles),
    "data-component-id": _ctx.id,
    onMousedown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.startMove && _ctx.startMove(...args))),
    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onItemClick(_ctx.id)))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "resizer top-left",
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.startResize('top-left')), ["stop"]))
      }, null, 32),
      _createElementVNode("div", {
        class: "resizer top-right",
        onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.startResize('top-right')), ["stop"]))
      }, null, 32),
      _createElementVNode("div", {
        class: "resizer bottom-left",
        onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.startResize('bottom-left')), ["stop"]))
      }, null, 32),
      _createElementVNode("div", {
        class: "resizer bottom-right",
        onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.startResize('bottom-right')), ["stop"]))
      }, null, 32)
    ])
  ], 46, _hoisted_1))
}